import { FC } from "react";
import { Timeline } from "src/components";
import { useTranslation } from "react-i18next";
import { FlightType } from "src/Modules/Flights/constants";
import { explode, formatTimeFromUnit } from "src/utility";
import { formatDate } from "src/utility/time";
import {AirplaneIcon} from "src/assets/Icons";

const FlightPath: FC<{ flight: FlightType }> = ({ flight }) => {
  const { t } = useTranslation();
  const { origin, destination, arrival, departure, durationMinutes } = explode(flight, {});
  const parsedArrivalTime = formatDate(arrival, "hh:mm A");
  const parsedDepartureTime = formatDate(departure, "hh:mm A");
  const duration = formatTimeFromUnit(durationMinutes, "m");
  const OriginItem = (
    <div className="flex flex-1 flex-col items-start justify-start">
      <div className="text-font-default text-lg font-bold whitespace-nowrap md:text-2xl">{parsedDepartureTime}</div>
      <div className="text-font-default text-sm font-bold">{origin.code}</div>
      <div className="text-font-subtle mt-0.5 flex flex-col text-xs">
        <span>{origin.name}</span>
        {origin.terminal && <span>{t("Flights.details.flightPath.terminal", { terminal: origin.terminal })}</span>}
      </div>
    </div>
  );
  const DestinationItem = (
    <div className="flex flex-1 flex-col items-end justify-end text-end">
      <div className="text-font-default text-lg font-bold whitespace-nowrap md:text-2xl">{parsedArrivalTime}</div>
      <div className="text-font-default text-sm font-bold">{destination.code}</div>
      <div className="text-font-subtle mt-0.5 flex flex-col items-end text-xs">
        <div>{destination.name}</div>
        {destination.terminal && <div>{t("Flights.details.flightPath.terminal", { terminal: destination.terminal })}</div>}
      </div>
    </div>
  );
  const ConnectorOverlay = (
    <div className="text-font-secondary flex flex-col items-center gap-1 text-xs font-medium whitespace-nowrap">
      {duration}
      <span className="bg-background-default px-2">
        <AirplaneIcon fill="var(--color-icon-secondary)" className="size-5" transform="rotate(-90)" />
      </span>
    </div>
  );

  return (
    <div className="flex w-full items-start justify-between gap-4">
      <div className="flex-1">{OriginItem}</div>
      <div className="flex-3 self-center">
        <Timeline
          items={[<></>, <></>]}
          connectorOverlays={[ConnectorOverlay]}
          classNames={{
            connector: {
              rail: "border-border-default h-0! border-t! border-dashed! translate-y-1/2!",
              head: "border-border-active bg-background-default! size-2! border",
              overlay: "-translate-y-3/4!",
            },
          }}
        />
      </div>
      <div className="flex-1">
         {DestinationItem}
      </div>
    </div>
  );
};

export default FlightPath;
